import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import {ManagementState} from "./redux";

export const managementSelector = (state: RootState) => state.management;
export const paramsSelector = createSelector(managementSelector, (state: ManagementState) => state.params);
